/* External */
import { memo } from 'react';
import PropTypes from 'prop-types';

/* Components */
import FeaturedCarouselSkeleton from '../FeaturedCarouselSkeleton';
import SwimlaneLiveSkeleton from '../SwimlaneLiveSkeleton';

/* Styles */
import './LanderSkeleton.scss';

function LanderSkeleton({ withoutFeatured }) {
  return (
    <div className="dtv-html5-lander-skeleton">
      {withoutFeatured ? <SwimlaneLiveSkeleton /> : <FeaturedCarouselSkeleton />}
      <SwimlaneLiveSkeleton />
    </div>
  );
}

LanderSkeleton.propTypes = {
  withoutFeatured: PropTypes.bool,
};

LanderSkeleton.defaultProps = {
  withoutFeatured: false,
};

export default memo(LanderSkeleton);
